import { DateTime } from 'luxon';
let now = DateTime.now();

export default function rezone(el){

	let dt = DateTime.fromSQL(el.getAttribute('data-date'), {zone: 'UTC'});
	let dt_local = dt.setZone(now.zoneName);
	el.innerHTML = dt_local.toLocaleString({ month: 'long', day: 'numeric', year: 'numeric' });
	el.classList.remove('rezone_expected');

};